type LexicalNode = {
    type: string;
    text?: string;
    format?: number;
    tag?: string;
    listType?: string;
    children?: LexicalNode[];
    [key: string]: any;
};

function convertNodeToHTML(node: LexicalNode): string {
    switch (node.type) {
        case 'root':
            return node.children?.map(convertNodeToHTML).join('') ?? '';

        case 'paragraph':
            return `<p>${node.children?.map(convertNodeToHTML).join('') ?? ''}</p>`;

        case 'list':
            const tag = node.listType === 'number' ? 'ol' : 'ul';
            return `<${tag}>${node.children?.map(convertNodeToHTML).join('')}</${tag}>`;

        case 'listitem':
            return `<li>${node.children?.map(convertNodeToHTML).join('') ?? ''}</li>`;

        case 'text':
            let content = node.text ?? '';
            const format = node.format ?? 0;
            if (format & 1) content = `<b>${content}</b>`;
            if (format & 2) content = `<i>${content}</i>`;
            if (format & 4) content = `<u>${content}</u>`;
            if (format & 8) content = `<s>${content}</s>`;
            return content;

        default:
            return node.children?.map(convertNodeToHTML).join('') ?? '';
    }
}

export function renderLexicalRichText(lexicalJSON: any): string {
    if (!lexicalJSON || !lexicalJSON.root) return '';
    return convertNodeToHTML(lexicalJSON.root);
}
